module.exports = __webpack_public_path__ + "static/step2_mission_pay_card_3-b0f808ec94086084304708d179855ce0.svg";